import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate, Navigate } from "react-router-dom";
import { getUser, getToken, getConfirmPurchaseRoute } from "../../Utils/Common";
import { useSelector, useDispatch } from "react-redux";
import { setUserCredits } from "../../features/counter/counterSlice";
import ReactStars from "react-rating-stars-component";

import { ResponseMessage } from "../../components/messages/response-message";
import "./book-read.css";

export default function ConfirmPurchase() {
  const [avgRating, setAvgRating] = useState(null);
  const [loader, setLoader] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [data, setData] = useState([]);
  const [sucessMessage, setsucessMessage] = useState("");
  const [error, setError] = useState([]);
  const [status, setStatus] = useState("");
  const [message, setMessage] = useState("");
  const redirectTo = getConfirmPurchaseRoute();

  const dispatch = useDispatch();

  const { book_code } = useParams();
  const user = getUser();
  const token = getToken();
  const navigate = useNavigate();

  useEffect(() => {
    setLoader(false);
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    setError(null);
    setsucessMessage("");

    var formData = new FormData();
    formData.append("book_code", book_code);
    formData.append("user_id", user.id);

    axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}v1/user/purchase-book`,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      data: formData,
    })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setsucessMessage(response.data.message);
          setStatus(200);
          setMessage(response.data.message);
          localStorage.setItem("thanks message", response.data.message);
          localStorage.setItem("book code", book_code);
          dispatch(setUserCredits(response.data.data));
          window.location.reload(navigate("/user/thanks"));
        }
      })
      .catch((error) => {
        console.log(error.response);
        if (error.response.status === 422) {
          setStatus(422);
          setMessage(error.response.data.message);
          setError(error.response.data.message);
        } else if (error.response.status === 401) {
          setStatus(401);
          setMessage(error.response.data.message);
          setError(error.response.data.message);
        } else if (error.response.status === 500) {
          setStatus(500);
          setMessage(error.response.data.message);
          setError(error.response.data.message);
        } else if (error.response.status === 402) {
          setStatus(402);
          setMessage(error.response.data.message);
          console.log(error.response.data.message);

          setError(error.response.data.message);
        } else {
          setMessage(error.response.data.message);
          setError("Something went wrong. Please try again later.");
        }
      });
  };

  // console.log(redirectTo);

  // console.log(user.user_type);

  // console.log(book_code);

  console.log(typeof redirectTo);
  const handleMove = () => {
    navigate("/book-detail/" + book_code);
  };

  return (
    <>
      <div
        className="d-flex flex-column flex-root"
        style={{ marginTop: "170px" }}
      >
        <div className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed">
          <div className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20">
            <div className="d-flex justify-content-center">
              <div
                className={loader === true ? "spinner-border" : ""}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
            <ResponseMessage status={status} message={message} />
            <div className="w-lg-500px bg-body border-black p-10 p-lg-15">
              <div className="text-center mb-10">
                <h1 className="text-dark fw-bolder">
                  {" "}
                  Use one credit to get the book{" "}
                </h1>
                <div className="text-center mt-9">
                  <button
                    className="btn btn-lg btn-dark w-100 mb-5"
                    onClick={handleSubmit}
                  >
                    <span className="indicator-label">
                      Confirm the Purchase{" "}
                    </span>
                  </button>
                </div>
                <div className="text-start fs-1 ">
                  <p>
                    {" "}
                    By completing your purchase, you agree to the Terms of Use.
                    Please review our Privacy Policy and our Advertising and
                    Cookies Policy.{" "}
                  </p>
                </div>
              </div>

              <div className="fv-row mb-10">
                <div className="d-flex flex-stack mb-2"></div>
              </div>
              <div className="text-center">
                <button className="cancel-button" onClick={handleMove}>
                  <span className="indicator-label">Cancel</span>
                </button>
              </div>
            </div>
          </div>
          <div className="d-flex flex-center flex-column-auto p-10">
            <div className="d-flex align-items-center fw-bold fs-6">
              <a href="/#" className="text-muted text-hover-primary px-2">
                About
              </a>
              <a href="/#" className="text-muted text-hover-primary px-2">
                Contact
              </a>
              <a href="/#" className="text-muted text-hover-primary px-2">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
